import type { MarketView } from '@ps/web-sports-api-types';

import type { Event } from '@swf/sports/components/Event/types';

import type { EventTypesEventIdsMap } from '../providers/LiveDataProvider';

export const getEventTypesInPlayEventIdsMap = (eventsList?: Event[]): EventTypesEventIdsMap =>
  eventsList?.reduce((acc: EventTypesEventIdsMap, event) => {
    if (event.market?.inPlay) {
      const currentEventIds = acc[event.eventTypeId] ?? [];
      return {
        ...acc,
        [event.eventTypeId]: [event.eventId, ...currentEventIds]
      };
    }
    return acc;
  }, {}) ?? {};

export const getEventTypesInPlayEventIdsFromMarketViewsMap = (
  markets: MarketView[]
): EventTypesEventIdsMap =>
  markets.reduce((acc: EventTypesEventIdsMap, market) => {
    if (market.inPlay) {
      const currentEventIds = acc[market.eventTypeId] ?? [];
      return {
        ...acc,
        [market.eventTypeId]: [market.eventId, ...currentEventIds]
      };
    }
    return acc;
  }, {});
